import { SVGProps } from 'react'

const BluechipLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'1em'}
    height={'1em'}
    viewBox="0 0 9.542 12.423"
    fill="none"
    {...props}
  >
    <path
      fill="#0101F5"
      d="M.633 3.174H8.71v.268H3.19a2.558 2.558 0 0 0 0 5.116H8.71v.269H.633v2.423h7.942a2.558 2.558 0 0 0 0-5.116H3.056v-.268h5.519a2.558 2.558 0 0 0 0-5.116H.633v2.424Z"
    />
  </svg>
)

export default BluechipLogo
